import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import * as Assets from "../../utils/svg_assets";
import * as Colors from "../../utils/color_themes";
import * as PageRoutes from "../../utils/route_pages";
import AddToHomeScreen from "../AddToHomeScreen";
import BottomNavigation from "../BottomNavigation";
import { getIconFromOrg } from "../../utils/utilities";
import Drawer from "react-modern-drawer";
import "./style.scss";
import { ConfirmationDialog } from "../DialogCollection";

export const BaseWithNav = ({ index, children, show_menu = true }) => {
  const navigate = useNavigate();
  const orgData = useSelector((state) => state.LoginSM.orgData);
  const [showCreatePage, setShowCreatePage] = useState(false);
  const [showNavigation, setShowNavigation] = useState(show_menu);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const createPostOnClick = () => {
    setShowNavigation(showCreatePage);
    setShowCreatePage(!showCreatePage);
  };

  const bottomNavItems = [
    {
      title: "Home",
      icon: (
        <img
          src={
            Object.keys(orgData).length > 0
              ? getIconFromOrg(orgData, "icon_main_home")
              : Assets.iconHome
          }
          width="24px"
          alt="home"
        />
      ),
      activeIcon: (
        <img
          src={
            Object.keys(orgData).length > 0
              ? getIconFromOrg(orgData, "icon_main_home_active")
              : Assets.iconHomeActive
          }
          width="24px"
          alt="home"
        />
      ),
      onClick: () => navigate(PageRoutes.home),
    },
    {
      title: "Reward",
      icon: (
        <img
          src={
            Object.keys(orgData).length > 0
              ? getIconFromOrg(orgData, "icon_main_rewards")
              : Assets.iconReward
          }
          width="24px"
          alt="reward"
        />
      ),
      activeIcon: (
        <img
          src={
            Object.keys(orgData).length > 0
              ? getIconFromOrg(orgData, "icon_main_rewards_active")
              : Assets.iconRewardActive
          }
          width="24px"
          alt="reward"
        />
      ),
      onClick: () => navigate(PageRoutes.reward),
    },
    {
      title: "Create",
      icon: (
        <img
          src={
            Object.keys(orgData).length > 0
              ? getIconFromOrg(orgData, "icon_main_create")
              : Assets.iconCreate
          }
          width="24px"
          alt="create"
        />
      ),
      activeIcon: (
        <img
          src={
            Object.keys(orgData).length > 0
              ? getIconFromOrg(orgData, "icon_main_create_active")
              : Assets.iconCreateActive
          }
          width="24px"
          alt="create"
        />
      ),
      onClick: createPostOnClick,
    },
    {
      title: "Support",
      icon: (
        <img
          src={
            Object.keys(orgData).length > 0
              ? getIconFromOrg(orgData, "icon_main_support")
              : Assets.iconSupport
          }
          width="24px"
          alt="support"
        />
      ),
      activeIcon: (
        <img
          src={
            Object.keys(orgData).length > 0
              ? getIconFromOrg(orgData, "icon_main_support_active")
              : Assets.iconSupportActive
          }
          width="24px"
          alt="support"
        />
      ),
      onClick: () => navigate(PageRoutes.support),
    },
    {
      title: "Account",
      icon: (
        <img
          src={
            getIconFromOrg(orgData, "icon_main_account")
              ? getIconFromOrg(orgData, "icon_main_account")
              : Assets.iconProfile
          }
          width="24px"
          alt="account"
        />
      ),
      activeIcon: (
        <img
          src={
            getIconFromOrg(orgData, "icon_main_account")
              ? getIconFromOrg(orgData, "icon_main_account_active")
              : Assets.iconProfileActive
          }
          width="24px"
          alt="account"
        />
      ),
      onClick: () => navigate(PageRoutes.account),
    },
  ];

  return (
    <>
      <Row className="zeropm">
        <Col sm={0} md={3} />
        <Col sm={12} md={6} className="vh-100 main_layout zeropm">
          {children}
          {showNavigation && (
            <BottomNavigation
              items={bottomNavItems}
              selected={index}
              activeBgColor={"white"}
              activeTextColor={Colors.primaryColor}
            />
          )}

          <AddToHomeScreen appId="skorpoints-pwa-testing-id" />
        </Col>
        <Col sm={0} md={3} />
      </Row>
      <Drawer
        open={showCreatePage}
        onClose={createPostOnClick}
        direction="bottom"
        // size={180}
        overlayColor={"#080707"}
        overlayOpacity={0.5}
        style={{
          borderRadius: "20px 20px 0 0",
          padding: "20px",
        }}
      >
        <div className="create-post">
          <div className="create-post-title">Create</div>
          <Row onClick={() => navigate(PageRoutes.create)}>
            <Col xs={2} sm={2} md={2}>
              <div className="icon-wrapper">
                <i>
                  <img
                    src={Assets.iconCreatePost}
                    width="24px"
                    alt="Icon Create Post"
                  />
                </i>
              </div>
            </Col>
            <Col className="create-post-title-label"> Create a post</Col>
          </Row>
          <Row onClick={() => setOpenConfirmDialog(true)}>
            <Col xs={2} sm={2} md={2}>
              <div className="icon-wrapper">
                <i>
                  <img
                    src={Assets.iconCreateReport}
                    width="24px"
                    alt="Icon Create Post"
                  />
                </i>
              </div>
            </Col>
            <Col className="create-post-title-label"> Create a Report</Col>
          </Row>
          <Row onClick={() => navigate(`${PageRoutes.snapReceipt}/?openModal=true`)}>
            <Col xs={2} sm={2} md={2}>
              <div className="icon-wrapper">
                <i>
                  <img
                    src={Assets.iconReceipt}
                    width="24px"
                    alt="Icon Create Post"
                  />
                </i>
              </div>
            </Col>
            <Col className="create-post-title-label"> Add a receipt</Col>
          </Row>
          <ConfirmationDialog
            title="Report"
            confirmLabel="Yes"
            cancelLabel="No"
            message="Do you want to submit your reports anonymously?"
            show={openConfirmDialog}
            onCancel={() => {
              navigate(`${PageRoutes.createReport}/0`);
            }}
            onConfrim={() => navigate(`${PageRoutes.createReport}/1`)}
          />
        </div>
      </Drawer>
    </>
  );
};

export const Base = ({ children, bgColor = "#FFFFFF" }) => {
  return (
    <Row className="zeropm">
      <Col sm={0} md={3} />
      <Col
        sm={12}
        md={6}
        style={{ backgroundColor: bgColor }}
        className="vh-100 main_layout zeropm"
      >
        {children}

        <AddToHomeScreen appId="skorpoints-pwa-testing-id" />
      </Col>
      <Col sm={0} md={3} />
    </Row>
  );
};
